import * as React from 'react';
import { useSelector } from 'react-redux';
import { Progress } from 'antd';
import { getMetricDisplayName, getMetricShortName } from '@utils/metrics';
import useSetSummaryExport from '@components/top-widget-panel/spi-panel/hooks/useSetSummaryExport';
import { getMetricTitle, sortKPIMetricsData } from './utils';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import {
  IOCategoryWrapper,
  IOItemContentWrapper,
  IOItemTitleWrapper,
  IOItemValueWrapper,
  IOWidgetWrapper,
} from './styled';
import { RED_COLOR } from '../constants';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

const ImprovementOpportunitiesWidget = ({
  data = {},
  selectedChartMetric,
  onWidgetCardClick: onMetricBarClick,
}) => {
  const improvementMetricData = sortKPIMetricsData(data) || [];
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const activeMetricKeys = Object.keys(currentMetricsMeta);

  const improvementMetricDataFiltered = improvementMetricData.filter(({ name }) =>
    activeMetricKeys.includes(name),
  );

  useSetSummaryExport({
    totals: data,
    category: {
      name: 'Improvement Opportunities',
      metrics: (improvementMetricDataFiltered ?? []).map(({ name }) => name),
    },
  });

  return (
    <IOWidgetWrapper>
      <IOCategoryWrapper>
        {improvementMetricDataFiltered.map(({ name, value }) => {
          const displayName = getMetricDisplayName({ metricKey: name });
          const invertedMetric = getInvertedPercentageMetricByKey({ metricKey: name });
          const short = getMetricShortName({ metricKey: name, hasSubscript: false });
          return (
            <IOItemContentWrapper
              title={displayName}
              key={name}
              onClick={
                value !== undefined ? () => onMetricBarClick(invertedMetric, value) : undefined
              }
              isClickable={value !== undefined}
              $highlight={invertedMetric === selectedChartMetric}
            >
              <IOItemTitleWrapper>{short}</IOItemTitleWrapper>
              <IOItemValueWrapper>{getMetricTitle(name, value)}</IOItemValueWrapper>
              <Progress
                percent={value}
                strokeColor={RED_COLOR}
                style={{ margin: 0, padding: 0, width: '100px', top: '-1px' }}
                type="line"
                strokeWidth={7}
                size="small"
                showInfo={false}
              />
            </IOItemContentWrapper>
          );
        })}
      </IOCategoryWrapper>
    </IOWidgetWrapper>
  );
};

export default ImprovementOpportunitiesWidget;
